import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { omit } from 'lodash'
import { clientActionUpdateLogLevels, ClientLogStream, LogConfig, LogSeverity } from 'api'
import { Locale, Translation } from 'locale'
import { WindowActions } from 'epics/windowEpic'
import { platformDetailSelector } from 'selectors/platformSelectors'
import { CenterPanel } from 'view/routes/routesLayout'
import { DetailTilesContainer, EnvironmentTitle, HeroPanel } from 'view/shared/heroPanel'
import { ClientLogStreamScreen } from './ClientLogStreamScreen'

export const ClientLogStreamScreenContainer: React.FC = () => {
  const platformDetail = useSelector(platformDetailSelector)
  const dispatch = useDispatch()

  const logConfig = platformDetail?.platform.clientLogConfig.config
  const handleOnChange = useCallback(
    (logStream: ClientLogStream, logLevel: LogSeverity | undefined) => {
      const updatedConfig: LogConfig = { ...omit(logConfig, logStream), ...(logLevel ? { [logStream]: logLevel } : undefined) }
      dispatch(clientActionUpdateLogLevels(updatedConfig))
    },
    [logConfig, dispatch]
  )

  return logConfig ? (
    <CenterPanel>
      <HeroPanel onTearout={() => dispatch(WindowActions.tearoutGrid('/quote/tearout/admin/platform/clientLogging'))}>
        <DetailTilesContainer>
          <EnvironmentTitle data-test-id={'PlatformClientLogging-EnvironmentTitle'}>
            {Locale.translate(Translation.TC_SECTION_PLATFORM_CLIENT_LOGSTREAMS)}
          </EnvironmentTitle>
        </DetailTilesContainer>
      </HeroPanel>
      <ClientLogStreamScreen logConfig={logConfig} onChange={handleOnChange} />
    </CenterPanel>
  ) : null
}
